import { clamp } from '@/motion/math';

/** Arrow keys move the divider 5 %; Page Up / Down move it 10 %. */
export const COMPARE_KEY_STEP = 5;
export const COMPARE_PAGE_STEP = 10;

/**
 * The slider keyboard contract: where the divider goes for `key` from `value`, or `null` when the key
 * is not one the slider handles (so the page keeps it). Values stay on 0 – 100.
 */
export function compareFromKey(key: string, value: number): number | null {
  switch (key) {
    case 'ArrowLeft':
    case 'ArrowDown':
      return clamp(value - COMPARE_KEY_STEP, 0, 100);
    case 'ArrowRight':
    case 'ArrowUp':
      return clamp(value + COMPARE_KEY_STEP, 0, 100);
    case 'PageDown':
      return clamp(value - COMPARE_PAGE_STEP, 0, 100);
    case 'PageUp':
      return clamp(value + COMPARE_PAGE_STEP, 0, 100);
    case 'Home':
      return 0;
    case 'End':
      return 100;
    default:
      return null;
  }
}

/** Snap a dragged value to something a sentence can say: whole percentages. */
export const roundCompare = (value: number): number => Math.round(clamp(value, 0, 100));
